<span appStopNumberScrolling [ngClass]="{'dark-theme': isDarkTheme}">
  <router-outlet></router-outlet>
</span>
